import { archiveItems } from "@/mocks/home";

export default function ArchiveSection() {
  return (
    <section id="archive" className="w-full px-4 md:px-8 py-14 md:py-20">
      <div className="max-w-[1360px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <span className="text-[11px] font-label tracking-[0.24em] text-primary-600">SOURCE ARCHIVE</span>
            <h2 className="mt-2 font-heading text-3xl md:text-[2.4rem] font-black leading-tight text-foreground-950">
              原文收录
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-500">
              声明的每一个版本、客服的每一句答复、公告的每一处补充，都按发布时间原样收录在这里。引用前请以原始发布渠道为准。
            </p>
            <div className="mt-6 rounded-lg border border-background-200 bg-background-100 p-4">
              <div className="flex items-center gap-2 text-[11px] font-label text-foreground-500">
                <i className="ri-shield-check-line text-secondary-600" />
                收录规则
              </div>
              <p className="mt-2 text-xs leading-relaxed text-foreground-500">
                仅收录公开发布且可检索的内容，不收录私密聊天记录，不对当事人身份做任何推断。
              </p>
            </div>
          </div>

          <div className="lg:col-span-8 space-y-5">
            {archiveItems.map((item) => (
              <article
                key={item.title}
                className="relative rounded-lg border border-background-200 bg-background-100 p-5 md:p-6 hover:border-primary-300 transition-colors"
              >
                <div className="flex flex-wrap items-center gap-x-4 gap-y-2 mb-3">
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 text-primary-800 px-2.5 py-0.5 text-[11px] font-label">
                    <i className="ri-quote-text" />
                    {item.tag}
                  </span>
                  <span className="text-[11px] font-label text-foreground-400">{item.source}</span>
                  <span className="text-[11px] font-label text-foreground-400 tabular-nums">{item.date}</span>
                </div>
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">{item.title}</h3>
                <blockquote className="mt-3 border-l-2 border-accent-400 pl-4 font-heading text-sm md:text-[15px] leading-relaxed text-foreground-700">
                  {item.quote}
                </blockquote>
                <div className="mt-4 flex flex-wrap items-center gap-4">
                  <span className="inline-flex items-center gap-1.5 text-[11px] font-label text-primary-600 cursor-pointer">
                    <i className="ri-file-copy-line" />
                    复制引用
                  </span>
                  <span className="inline-flex items-center gap-1.5 text-[11px] font-label text-foreground-500 cursor-pointer">
                    <i className="ri-history-line" />
                    查看版本差异
                  </span>
                  <span className="ml-auto inline-flex items-center gap-1.5 text-[11px] font-label text-foreground-400">
                    <i className="ri-verified-badge-line text-secondary-600" />
                    已核对来源
                  </span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}